import React from 'react';
import { Button, Tooltip, Tag, Table, Empty } from 'antd';
import global from '../../../common/utility/global';


export default function ResultList(props) {
    return (

        <Table
            bordered={props.bordered === undefined ? false : props.bordered}
            style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}
            title={() => (
                <div style={{ width: '100%', textAlign: "right" }} hidden={false}>
                    <div className="custom-options">
                        {
                            (props.onExportExcel === undefined || props.isCancelado) ? null :
                                <Button ghost
                                    type="success"
                                    icon="file-excel"
                                    onClick={props.onExportExcel}
                                    style={{ color: '#3fb703' }}
                                    loading={props.loadingExcel}
                                >
                                    Excel
                                </Button>
                        }
                        {
                            props.onExportPdf === undefined ? null :
                                <Button ghost
                                    type="danger"
                                    icon="file-pdf"
                                    onClick={props.onExportPdf}
                                    style={{ color: '#ff4d4f' }}
                                    loading={props.loadingPdf}
                                    hidden={true}

                                >
                                    Pdf
                                </Button>
                        }

                    </div>
                </div>
            )}
            loading={
                props.pagination.loading ? {
                    tip: "Un momento por favor",
                    size: "large"
                } : false
            }
            size="small"
            rowKey={record => record.uid}
            dataSource={props.pagination.data}
            onChange={(pagination, filters, sorter) => {
                props.onChange({
                    page: pagination.current,
                    order: sorter.order,
                    field: sorter.field
                })
            }}

            /*     rowSelection={{
                    onChange: props.onChangeRow,
                    //selectedRowKeys: this.props.formValues.selectedRowKeys,
                    hideDefaultSelections: false
                }} */
            locale={{
                emptyText: <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No se encontraron datos."
                />
            }}
            pagination={{
                total: props.pagination.total,
                current: props.pagination.page,
                pageSize: props.pagination.pageSize,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}

            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            {props.isCancelado ?
                                <Tooltip placement="top" title="Eliminar">
                                    <Button
                                        type="danger"
                                        icon="close"
                                        size={"small"}
                                        onClick={() => props.onAnular(row)}
                                    />
                                </Tooltip> :
                                <Tooltip placement="top" title="Agregar Pago">
                                    <Button
                                        type="primary"
                                        icon="plus"
                                        loading={props.loadingPago}
                                        size={"small"}
                                        onClick={() => props.onViewPago(row)}
                                    />
                                </Tooltip>
                            }
                        </div>
                    )
                },

                {
                    title: 'Fecha Comprobante',
                    dataIndex: 'fechaStr',
                    key: 'fecha',
                    width: "90px",

                    sorter: true
                },
                {
                    title: 'Nro Comprobante',
                    dataIndex: 'serieDocumentoComprobante',
                    key: 'comprobante',
                    width: "90px",

                    sorter: true
                },
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'nombreTipoComprobante',
                    key: 'tipoComprobante',
                    width: "90px",
                    sorter: true
                },
                {
                    title: 'Forma Pago',
                    dataIndex: 'formaPago',
                    key: 'formaPago',
                    width: "90px",
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimiento',
                    key: 'fechaVencimiento',
                    width: "90px",

                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {

                                var valuesStart = global.fetchCurrentDateStr().split("/");
                                var valuesEnd = value.split("/");

                                // Verificamos que la fecha no sea posterior a la actual
                                var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
                                var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);

                                if (dateStart > dateEnd && !props.isCancelado) {
                                    return <Tag color={"red"}>{value}</Tag>;
                                }
                                return <span>{value}</span>;

                            })()}

                        </div>)
                    }
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    width: "90px",

                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    width: "90px",

                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    width: "90px",

                    sorter: true
                },
                {
                    title: 'Cuota',
                    dataIndex: 'couta',
                    key: 'couta',
                    width: "90px",

                    sorter: true
                },


                {
                    title: 'Moneda Original',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    width: "90px",
                    sorter: true
                },

                {
                    title: 'Total',
                    dataIndex: 'totalSoles',
                    key: 'totalSoles',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    width: "90px",
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Cobrado',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'canceladoSoles',
                            key: 'canceladoSoles',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'canceladoDolares',
                            key: 'canceladoDolares',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        }
                    ]
                },

                {
                    title: 'Por Cobrar',
                    dataIndex: 'saldoSoles',
                    key: 'saldoSoles',
                    align: 'right',
                    className: props.isCancelado ? 'hide' : 'show',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'idCuentasEstado',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    className: props.isCancelado ? 'hide' : 'show',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 1: //pendiente NV
                                        return <Tag color={"red"}>{row.nombreCuentasEstado}</Tag>;

                                    case 2: //registado
                                        return <Tag color={"red"}>{row.nombreCuentasEstado}</Tag>;
                                    case 3://ANULADA
                                        return <Tag color={"blue"}>{row.nombreCuentasEstado}</Tag>;
                                    case 5://ANULADA
                                        return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;

                                    default:
                                        return null;
                                }
                            })()}

                        </div>)
                    }
                }
            ]}
        />
    );
}